var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "custom-int-container" }, [_c('div', { staticStyle: { "margin-bottom": "10px" } }, [_c('el-slider', { attrs: { "step": _vm.step, "min": _vm.min, "max": _vm.max, "marks": _vm.marks }, on: { "change": _vm.changeHandler }, model: { value: _vm.value, callback: function callback($$v) {
        _vm.value = $$v;
      }, expression: "value" } })], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };